import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

/**
 * EmailGate — inline Google sign-in prompt for mailing list / beta signups.
 * Unlike GoogleSignInGate (which blocks the entire page), this only gates
 * a specific action.  Once signed in, it renders children with the user's
 * email pre-filled via the render-prop pattern.
 *
 * Usage:
 *   <EmailGate>
 *     {(user) => <form>…</form>}
 *   </EmailGate>
 *
 * If the user is not signed in, a compact Google sign-in card is shown.
 * If the user IS signed in, `children(user)` is rendered.
 */
export default function EmailGate({ children, prompt }) {
  const { user, loading, handleGoogleSuccess } = useAuth();

  if (loading) return null;

  if (!user) {
    return (
      <div className="email-gate">
        <p className="email-gate-prompt">
          {prompt || 'Sign in with Google to join — we only use your email.'}
        </p>
        <div className="google-btn-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => console.error('Google Sign-In failed')}
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
            width="300"
          />
        </div>
      </div>
    );
  }

  return typeof children === 'function' ? children(user) : children;
}
